var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7142 5.599L17.2196 1.18463C17.0991 1.0663 16.937 1 16.768 1H5.40491C4.07892 1 3 2.07875 3 3.40491V20.5951C3 21.9211 4.07875 23 5.40491 23H19.5022C20.8282 23 21.9071 21.9212 21.9071 20.5951V6.0589C21.9071 5.88585 21.8376 5.72018 21.7142 5.599ZM17.4125 3.181L19.6865 5.41437H17.6174C17.5045 5.41437 17.4125 5.32239 17.4125 5.20943V3.181ZM19.5022 21.7109H5.40491C4.78975 21.7109 4.28906 21.2104 4.28906 20.5951V3.40491C4.28906 2.78958 4.78958 2.28906 5.40491 2.28906H16.1236V5.20943C16.1236 6.03322 16.7938 6.70343 17.6176 6.70343H20.618V20.5951C20.618 21.2104 20.1175 21.7109 19.5022 21.7109Z",
    fill: "#1592D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9282 11.2266H7.84229C7.48628 11.2266 7.19775 11.5151 7.19775 11.8711C7.19775 12.2271 7.48628 12.5156 7.84229 12.5156H16.9282C17.2842 12.5156 17.5727 12.2271 17.5727 11.8711C17.5727 11.5151 17.2842 11.2266 16.9282 11.2266Z",
    fill: "#1592D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 15.0938H15.2507C15.6067 15.0938 15.8952 14.8052 15.8952 14.4492C15.8952 14.0932 15.6067 13.8047 15.2507 13.8047H7.84229C7.48628 13.8047 7.19775 14.0932 7.19775 14.4492C7.19775 14.8052 7.48628 15.0938 7.84229 15.0938Z",
    fill: "#1592D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1445 16.3828H7.84229C7.48628 16.3828 7.19775 16.6713 7.19775 17.0273C7.19775 17.3833 7.48628 17.6719 7.84229 17.6719H16.1445C16.5003 17.6719 16.789 17.3833 16.789 17.0273C16.789 16.6713 16.5003 16.3828 16.1445 16.3828Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.a909d08179ceeb3279f1a0df74201548.svg";
export { ForwardRef as ReactComponent };